<section class="auth-page">
  <div class="auth-panel">
    <span class="eyebrow">Cognito</span>
    <h2>Validando acceso</h2>
    <p *ngIf="!error">Estamos completando el authorization code flow.</p>
    <div class="state error" *ngIf="error">{{ error }}</div>
    <a class="ghost-button auth-link" routerLink="/login" *ngIf="error">Volver al login</a>
  </div>
</section>
